<template>
  <div class="customer-detail" v-if="user">
    <div class="customer-header pt-0">
      <slot name="header"></slot>
      <div class="text-xs-center">
        <v-avatar size="100" v-if="user.profile_pic">
          <v-img :src="user.profile_pic" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div class="mb-4 text-xs-center">
          <v-btn
            :href="'https://business.facebook.com' + user.inboxurl"
            target="_blank"
            small
            depressed
            round
            color="#3b5998"
            dark
            v-if="user.app == 'facebook' && user.inboxurl"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('View inbox') }}
          </v-btn>
        </div>
      </div>
    </div>
    <v-layout wrap>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Channel') }}</label>
        <p>
          <span style="color: #3b5998" v-if="user.app == 'facebook'">
            <em class="fab fa-facebook-square" /> Facebook
          </span>
          <span style="color: #00c300" v-else-if="user.app == 'line'">
            <em class="fab fa-line" /> Line
          </span>
        </p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('gender') }}</label>
        <p>{{ $t(user.gender) }}</p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Locale') }}</label>
        <p>
          <template v-if="userLocale">
            <flag :iso="userLocale.icon" />
            {{ userLocale.title }}
          </template>
          <template v-else>-</template>
        </p>
      </v-flex>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption">
          {{ $t('Status') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>
        <div>
          <p>
            <edit-customer-value
              v-model="user['status']"
              :userid="user.id"
              :placeholder="$t('Status')"
              @onEdit="onEditStatus"
            >
              <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
            </edit-customer-value>
          </p>
        </div>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-layout wrap>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Register Date') }}</label>
        <p>
          {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
        </p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Last Active Date') }}</label>
        <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Email') }}</label>
        <p>
          <edit-customer-value
            v-model="user['email']"
            :userid="user.id"
            :placeholder="$t('Email')"
            @onEdit="onEditEmail"
          >
            <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
          </edit-customer-value>
        </p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('phone no.') }}</label>
        <p>
          <edit-customer-value
            v-model="user['phoneno']"
            :userid="user.id"
            :placeholder="$t('phone no.')"
            @onEdit="onEditPhone"
          >
            <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
          </edit-customer-value>
        </p>
      </v-flex>

      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Context') }}</label>
        <p>
          <edit-customer-value
            v-model="user['context']"
            :userid="user.id"
            :placeholder="$t('Context')"
            @onEdit="onEditContext"
          >
            <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value>
          </edit-customer-value>
        </p>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-layout wrap>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('ชื่อจริง') }}</label>
        <edit-customer-value
          v-model="user['uu_name']"
          :userid="user.id"
          :placeholder="$t('ชื่อจริง')"
          @onEdit="onEditUuName"
          >{{ user.uu_name ? user.uu_name : '-' }}</edit-customer-value
        >
      </v-flex>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2" style="word-break: break-all">
        <label class="caption" for>{{ $t('รหัสผู้ใช้น้ำ') }}</label>
        <edit-customer-value
          v-model="user['uu_id']"
          :userid="user.id"
          :placeholder="$t('รหัสผู้ใช้น้ำ')"
          @onEdit="onEditUuID"
          >{{ user.uu_id ? user.uu_id : '-' }}</edit-customer-value
        >
      </v-flex>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2" style="word-break: break-all">
        <label class="caption" for>{{ $t('ประปา') }}</label>
        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditAreacode"
          @click="isEditAreacode = true"
        >
          <em class="fa fa-pencil-alt middle" />
        </a>

        <template v-if="!isEditAreacode">
          <p>
            {{ user.uu_areaname ? user.uu_areaname : '-' }}
            {{ user.uu_areacode ? `(${user.uu_areacode})` : '' }}
          </p>
        </template>
        <template v-else>
          <multiselect
            v-model="uuAreaName"
            :options="uuAreaNameOption"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            track-by="label"
            label="label"
            @select="onSelectAreaCode"
          ></multiselect>

          <div class="text-xs-center">
            <v-btn outline color="grey" small @click="cancelEditUuAreaName">{{
              $t('cancel')
            }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditUuAreaName">{{
              $t('Save')
            }}</v-btn>
          </div>
        </template>
      </v-flex>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2" style="word-break: break-all">
        <label class="caption" for>{{ $t('DMA') }}</label>

        <edit-customer-value
          v-model="user['uu_dma']"
          :userid="user.id"
          :placeholder="$t('DMA')"
          @onEdit="onEditUuDma"
          >{{ user.uu_dma ? user.uu_dma : '-' }}</edit-customer-value
        >
      </v-flex>
      <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2" style="word-break: break-all">
        <label class="caption" for>{{ $t('ตำแหน่ง') }}</label>
        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditLocation"
          @click="isEditLocation = true"
        >
          <em class="fa fa-pencil-alt middle" />
        </a>
        <template v-if="!isEditLocation">
          <p>
            <a
              v-if="uu_location != '0,0'"
              :href="`https://maps.google.com?q=${uu_location}`"
              target="_blank"
              rel="noopener noreferrer"
              >{{ uu_location }}</a
            >
            <template v-else>{{ uu_location }}</template>
          </p>
        </template>
        <template v-else>
          <div class="form-control">
            <input
              type="text"
              class="form-control"
              v-model="uu_location"
              placeholder="ตำแหน่ง"
              @blur="onBlurLocation"
              @input="onBlurLocation"
            />
          </div>
          <!-- <v-layout>
            <v-flex class="pa-1 form-control">
              <input type="text" class="form-control" v-model="user.uu_lat" placeholder="lat" />
            </v-flex>
            <v-flex class="pa-1 form-control">
              <input type="text" class="form-control" v-model="user.uu_long" placeholder="long" />
            </v-flex>
          </v-layout>-->
          <div class="text-xs-center">
            <v-btn outline color="grey" small @click="cancelEditLocation">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditLocation">{{
              $t('Save')
            }}</v-btn>
          </div>
        </template>
      </v-flex>
      <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2" style="word-break: break-all">
        <label class="caption" for>{{ $t('Address') }}</label>
        <edit-customer-value
          v-model="user['address']"
          :userid="user.id"
          :placeholder="$t('DMA')"
          @onEdit="onEditAddress"
        >
          <a
            v-if="user.address"
            :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              user.address
            )}`"
            target="_blank"
            rel="noopener noreferrer"
            >{{ user.address }}</a
          >
          <template v-else>-</template>
        </edit-customer-value>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <div class="pl-3 pr-3 pt-2 pb-2">
      <label class="caption" for>
        {{ $t('Tag') }}
        <v-premium-lock :inline="true"></v-premium-lock>
      </label>

      <a
        href="javascript:void(0);"
        v-if="$store.getters.getPackage == 'premium' && !isEditTag"
        @click="isEditTag = true"
      >
        <em class="fa fa-pencil-alt middle" />
      </a>
    </div>
    <div class="pl-3 pr-3 pt-2 pb-2">
      <template v-if="!isEditTag">
        <div class="left-align" v-if="tags.length == 0">{{ $t('No tag') }}</div>
        <ul class="tags">
          <li class="tag" v-for="(tag, index) in tags" :key="'usertag_' + index">
            <specialtext :text="tag"></specialtext>
          </li>
        </ul>
      </template>
      <template v-else>
        <tags
          v-model="usertag"
          :tags="usertags"
          @tags-changed="addUserTags"
          @before-adding-tag="checkUserTags"
          style="margin-bottom: 5px"
          :btnText="$t('Add tag')"
        ></tags>

        <div class="text-xs-center" style="margin-top: 15px">
          <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
        </div>
      </template>
    </div>

    <v-divider></v-divider>

    <div class="pl-3 pr-3 pt-2 pb-2">
      <label class="caption" for>{{ $t('Message Sent') }}</label>
      <div style="position: relative" margin-top="25">
        <v-premium-plan-popup
          :showAll="false"
          v-if="$store.getters.getPackage != 'premium'"
        ></v-premium-plan-popup>
        <div
          style="
            overflow-y: auto;
            max-height: 300px;
            padding: 5px;
            background: #f7f7f7;
            border: 1px solid #eee;
            border-radius: 5px;
          "
        >
          <template v-if="$store.getters.getPackage != 'premium'">
            <div
              v-for="(intent, index) in 10"
              :key="'intent_' + index"
              style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
            >
              <div
                style="
                  height: 15px;
                  position: relative;
                  top: 3px;
                  display: inline-block;
                  width: 100%;
                  max-width: 100px;
                  background-color: #eee;
                "
              ></div>
            </div>
          </template>
          <template v-else>
            <template v-if="filterIntent.length > 0">
              <div
                v-for="(intent, index) in filterIntent"
                :key="'intent_' + index"
                style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
              >
                <template v-if="$store.getters.getPackage == 'premium'">
                  {{ intentLabel(intent[0]) }}
                  ({{ intent[1] | numberFormat }})
                </template>
              </div>
            </template>
            <template v-else>
              <div class="text-center">{{ $t('No message sent') }}</div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
import Multiselect from 'vue-multiselect'
export default {
  props: {
    value: {
      default: undefined
    },
    pageid: {
      default: undefined
    }
  },
  data: function () {
    return {
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      isEditAreacode: false,
      isEditLocation: false,
      usertag: '',
      uuAreaNameOption: [
        {
          value: 1,
          label: 'ประปาบางปะกง'
        },
        {
          value: 2,
          label: 'ประปาฉะเชิงเทรา'
        },
        {
          value: 3,
          label: 'ประปาบ่อวิน'
        },
        {
          value: 4,
          label: 'ประปาหนองขาม'
        },
        {
          value: 5,
          label: 'ประปาสัตหีบ'
        },
        {
          value: 6,
          label: 'ประปาระยอง'
        },
        {
          value: 7,
          label: 'ประปานครสวรรค์'
        },
        {
          value: 8,
          label: 'ประปาหัวรอ'
        },
        {
          value: 0,
          label: 'นอกพื้นที่บริการ'
        }
      ],
      uuAreaName: null,
      uu_location: ''
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    specialtext,
    Tags,
    Multiselect
  },
  computed: {
    currentPageid() {
      return this.pageid ? this.pageid : this.selectedBot.pageid
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntent: function () {
      var vm = this
      if (vm.user.intentlist) {
        return vm.user.intentlist.sort(function (a, b) {
          if (parseInt(a[1]) > parseInt(b[1])) {
            return -1
          }

          if (parseInt(a[1]) < parseInt(b[1])) {
            return 1
          }

          return 0
        })
      } else return '-'
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  created() {
    this.getUserDetail(this.value.id)
  },
  mounted: function () {
    var vm = this
    this.user = this.value
    this.cached_tag = this.user.tags
    vm.cached_uu_areacode = vm.user.uu_areacode
    vm.cached_uu_areaname = vm.user.uu_areaname
    vm.cached_uu_lat = vm.user.uu_lat
    vm.cached_uu_long = vm.user.uu_long
    vm.uu_location =
      (vm.user.uu_lat ? vm.user.uu_lat : 0) + ',' + (vm.user.uu_long ? vm.user.uu_long : 0)

    vm.uuAreaName = vm.uuAreaNameOption.find(function (el) {
      return el.value == vm.user.uu_areacode
    })
  },
  methods: {
    getUserDetail: function (userid) {
      var vm = this
      var data = {
        userid: userid,
        pageid: vm.currentPageid
      }
      api.getUserOnly(data, function (error, response) {
        if (error) console.error(error)

        if (response.data) {
          vm.user = response.data[0]
        } else {
        }
      })
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value
      }
      api.saveUserContext(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onBlurLocation() {
      var location = this.uu_location.split(',')
      if (location.length > 0) {
        this.$set(this.user, 'uu_lat', location[0])
      } else {
        this.$set(this.user, 'uu_lat', 0)
      }
      if (location.length > 1) {
        this.$set(this.user, 'uu_long', location[1])
      } else {
        this.$set(this.user, 'uu_long', 0)
      }
    },
    onEditAddress: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value
      }
      api.saveUserAddress(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditUuID: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        uu_id: payload.customer_value
      }
      api.saveUuID(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onSelectAreaCode: function (payload) {
      var vm = this
      vm.uuAreaName = payload
      vm.user.uu_areacode = payload.value
      vm.user.uu_areaname = payload.label
    },
    onEditUuName: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        realname: payload.customer_value
      }
      api.saveUuRealName(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditUuDma: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        dma: payload.customer_value
      }
      api.saveUuDma(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    cancelEditUuAreaName: function () {
      var vm = this
      vm.user.uu_areacode = vm.cached_uu_areacode
      vm.user.uu_areaname = vm.cached_uu_areaname
      vm.isEditAreacode = false
    },
    saveEditUuAreaName: function () {
      var vm = this
      var data = {
        pageid: vm.currentPageid,
        usersid: vm.user.id,
        areacode: vm.user.uu_areacode,
        areaname: vm.user.uu_areaname
      }
      api.saveUuAreaname(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_uu_areacode = vm.user.uu_areacode
        vm.cached_uu_areaname = vm.user.uu_areaname
        vm.isEditAreacode = false
      })
    },
    cancelEditLocation: function () {
      var vm = this
      vm.user.uu_lat = vm.cached_uu_lat
      vm.user.uu_long = vm.cached_uu_long
      vm.isEditLocation = false
    },
    saveEditLocation: function () {
      var vm = this
      var data = {
        pageid: vm.currentPageid,
        usersid: vm.user.id,
        latitude: vm.user.uu_lat,
        longitude: vm.user.uu_long
      }
      api.saveUuLocation(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_uu_lat = vm.user.uu_lat
        vm.cached_uu_long = vm.user.uu_long
        vm.isEditLocation = false
      })
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.currentPageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/UuCustomerDetail.vue